"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putCommasIntoNumber = void 0;
/**
 * @deprecated Use `toLocaleString()` instead
 */
const putCommasIntoNumber = (n) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
exports.putCommasIntoNumber = putCommasIntoNumber;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHV0LWNvbW1hcy1pbnRvLW51bWJlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy9wdXQtY29tbWFzLWludG8tbnVtYmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBOztHQUVHO0FBQ0ksTUFBTSxtQkFBbUIsR0FBRyxDQUFDLENBQWtCLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBQyxRQUFRLEVBQUUsQ0FBQyxPQUFPLENBQUMsdUJBQXVCLEVBQUUsR0FBRyxDQUFDLENBQUM7QUFBakcsUUFBQSxtQkFBbUIsdUJBQThFIn0=